import { Storage } from '@iheartjane/utils';
import { useEffect, useState } from 'react';

import type { PromptsType } from './prompt.util';

// 1 day
const DISMISS_MILLISECONDS = 24 * 60 * 60 * 1000;

interface usePromptProps {
  dismissible: boolean;
  dismissTime?: number;
  prompt: PromptsType;
  showTime?: number;
}

export const usePrompt = ({
  prompt,
  dismissible,
  dismissTime = DISMISS_MILLISECONDS,
  showTime = 10,
}: usePromptProps): [boolean, () => void] => {
  const [showPrompt, setShowPrompt] = useState(false);

  const dismissPrompt = () => {
    const now = new Date();
    const newExpireTime = now.getTime() + dismissTime;
    Storage.set(prompt, newExpireTime);

    setShowPrompt(false);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    const expirationTime = Storage.get<number>(prompt);

    const expirationReached = expirationTime
      ? expirationTime <= new Date().getTime()
      : true;

    if (expirationReached) {
      Storage.remove(prompt);
      setShowPrompt(true);

      if (!dismissible) {
        timer = setTimeout(() => {
          dismissPrompt();
        }, showTime * 1000);
      }
    }

    return () => timer && clearTimeout(timer);
  }, []);

  return [showPrompt, dismissPrompt];
};
